<template>
  <div class="flex flex-col">

    <div class="w-full bg-gray-800 bg-no-repeat text-center" style="
      background-blend-mode: multiply;
      background-position: center center;
      background-size: contain;
      background-image: url('/img/PBC_Ninja.svg');
    ">
      <div class="p-10 px-20 py-6 pb-8 flex flex-col flex-wrap justify-center content-center">
        <div class="z-60 auth-content-rotate">
            <h1 class="text-white font-bold text-2xl">Unleash</h1>
            <h1 class="text-white text-xl -mt-3">Your inner</h1>
            <h2 class="text-blue-300 font-bold text-2xl -mt-2">Memelord <span class="text-white font-normal">or</span> Animation Ninja</h2>
        </div>
      </div>
    </div>

    <div class="md:w-2/3 self-center mt-2">
      <div v-if='chooseLoginMethod' class="flex flex-wrap justify-center">
        <!--
        <div class="w-full sm:w-1/2 sm:pr-2 mb-3 sm:mb-0">
          <button @click='facebookLogin'
            class="w-full bg-blue-800 hover:bg-blue-900 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
            type="button"
          >Login with Facebook</button>
        </div>
        -->
        <div class="w-full sm:w-64 sm:pl-2">
          <button @click='googleLogin'
            class="w-64 bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-2 focus:outline-none focus:shadow-outline items-center flex flex-row"
            type="button"
          >
              <svg width="24" height="24" viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg"><path d="M9 7.84363V11.307H13.8438C13.6365 12.428 12.9994 13.373 12.0489 14.0064V16.2534H14.9562C16.6601 14.6951 17.641 12.4029 17.641 9.67839C17.641 9.04502 17.5854 8.43176 17.4792 7.84865H9V7.84363Z" fill="#3E82F1"></path><path d="M9.00001 14.861C6.65394 14.861 4.67192 13.2876 3.96406 11.1714H0.955627V13.4937C2.43709 16.4142 5.48091 18.4198 9.00001 18.4198C11.432 18.4198 13.4697 17.6206 14.9562 16.2533L12.0489 14.0064C11.245 14.5443 10.2135 14.861 9.00001 14.861Z" fill="#32A753"></path><path d="M3.96404 5.45605H0.955617C0.348876 6.66246 0 8.02972 0 9.47238C0 10.915 0.348876 12.2823 0.955617 13.4887L3.96404 11.1714C3.78202 10.6335 3.6809 10.0605 3.6809 9.47238C3.6809 8.88426 3.78202 8.31122 3.96404 7.77336V5.45605Z" fill="#F9BB00"></path><path d="M0.955627 5.45597L3.96406 7.77327C4.67192 5.65703 6.65394 4.08368 9.00001 4.08368C10.3197 4.08368 11.5079 4.53608 12.4382 5.42078L15.0219 2.85214C13.4646 1.40948 11.427 0.52478 9.00001 0.52478C5.48091 0.52478 2.43709 2.53043 0.955627 5.45597Z" fill="#E74133" class="self-center"></path></svg>
              <span class="ml-3">Continue with Google</span>
          </button>
          <slot name='default' />
        </div>

        <!--
        <div class="w-full sm:w-1/2 sm:pl-2 pt-2">
          <button @click='loginOrCreate'
            class="w-full bg-gray-700 hover:bg-gray-800 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
            type="button"
          >Login Or Create Account</button>
        </div>
        -->
      </div>


    </div>
    <!--
    <amplify-sign-out :signOutConfig='{"msg":"cheeses"}' />
      <button class="text-black bg-gray-300 rounded mx-2" @click='googleLogin'>Google Login</button>
      <button class="text-black bg-gray-300 rounded mx-2" @click='facebookLogin'>Facebook Login</button>
      <button class="text-black bg-gray-300 rounded mx-2" @click='changeAttrs'>Change</button>
      <button class="text-black bg-gray-300 rounded mx-2" @click='test'>Test</button>
      <button class="text-black bg-gray-300 rounded mx-2" @click='test2'>Test2</button>
    -->

  </div>
</template>

<script>

export default {
  props: {
    loginState: {
      type: String,
      default() {
        return "";
      }
    }
  },
  mounted() {
    this.$ana.track({
      eventCategory: 'ui',
      eventAction: 'showLogin'
    });
  },
  beforeDestroy() {
  },
  data() {
    return {
      chooseLoginMethod: true,
      authConfig: {
        signUpConfig:{
          header: 'My Customized Sign Up',
          hideAllDefaults: true,
          signUpFields: [
            /*
            {
              label: 'My user name',
              key: 'username',
              required: true,
              displayOrder: 1,
              type: 'string',
            },
            */
            {
              label: 'My email',
              key: 'email',
              required: true,
              displayOrder: 1,
              type: 'string',
            },
            {
              label: 'Username',
              key: 'username',
              required: false,
              displayOrder: 2,
              type: 'string',
            },
            {
              label: 'Password',
              key: 'password',
              required: true,
              displayOrder: 3,
              type: 'password'
            },
          ]

        }
      },
    }
  },
  components:{
    //...components
  },
  methods: {
    googleLogin() {
      this.$amplify.Auth.federatedSignIn({
        provider:'Google',
        customState:encodeURIComponent(this.loginState)
      });
    },
    facebookLogin() {
      this.$amplify.Auth.federatedSignIn({
        provider:'Facebook',
        customState:encodeURIComponent(this.loginState)
      });
    },
    async changeAttrs() {
      const user = await this.$amplify.Auth.currentAuthenticatedUser();
      let result = await this.$amplify.Auth.updateUserAttributes(user, {
        'preferred_username': 'rashas2'
      });
      console.log('change stuff', result);
    },
    async test() {
      const session = await this.$amplify.Auth.currentSession();
      console.log('session', session);
      const idToken = session.getIdToken().getJwtToken();
      console.log('idToken', idToken);
      const url = 'https://sjp1xo921g.execute-api.eu-west-1.amazonaws.com/prod/test?t=' + new Date().getTime()
      const result = await fetch(url,{
        headers: {
          Authorization: idToken
        }
      });
      console.log('result', result);
      const data = await result.json();
      console.log('data', data);
    },
    async test2() {
      const session = await this.$amplify.Auth.currentSession();
      console.log('session', session);
      const idToken = session.getIdToken().getJwtToken();
      console.log('idToken', idToken);
      const url = 'https://sjp1xo921g.execute-api.eu-west-1.amazonaws.com/prod/?t=' + new Date().getTime()
      const result = await fetch(url,{
        headers: {
          Authorization: idToken
        }
      });
      console.log('result', result);
      const data = await result.json();
      console.log('data', data);
    },
    loginOrCreate() {
      this.chooseLoginMethod = false;
    }


  }
}
</script>
<style>
@media (max-width: 600px) {
  [data-test="sign-up-section"] {
    @apply p-0;
    @apply pr-2;
    @apply m-0;
    @apply min-w-0;
  }

  [data-test="sign-in-section"] {
    @apply p-0;
    @apply pr-2;
    @apply m-0;
    @apply min-w-0;
  }
  [data-test="confirm-sign-up-section"] {
    @apply p-0;
    @apply pr-2;
    @apply m-0;
    @apply min-w-0;
  }

  [data-test="username-input"] {
  }
  [data-test="sign-in-password-input"] {
  }
  [data-test="sign-in-footer-section"] {
    @apply p-0;
    @apply m-0;
    flex-direction: row;
  }
  [data-test="sign-in-footer-section"] span {
    @apply ml-0;
  }

}
.auth-content-rotate {
transform: rotate(-7deg);
overflow: hidden;
}

</style>
